import { ReactElement } from 'react';
import Image from 'next/image';

import { icon_arrow_right } from '@gn-audio/icons';

import { PopularSearches } from '../../../types';
import { useFallbackTranslation } from '../../../utils/hooks';
import { JabraIcon } from '../../JabraIcon/JabraIcon';
import { SearchTitleHeader } from './SearchTitleHeader';

type PopularProductsProps = {
  fields?: PopularSearches;
};

export const PopularProducts = ({ fields }: PopularProductsProps): ReactElement | null => {
  const { t } = useFallbackTranslation();
  const { getURLWithLocalePrefix } = useFallbackTranslation();

  const popularSearchText = fields?.popularSearchesText?.value || '';
  const learnMoreText = fields?.learnMoreText?.value || '';
  const popularSearches = fields?.content || [];

  if (popularSearches.length === 0) return null;

  return (
    <>
      <SearchTitleHeader title={popularSearchText} />
      <div
        className="mb-10 grid w-full grid-cols-1 gap-4 xs:grid-cols-2"
        aria-label={t('topmenu.PopularProducts')}
        role="list"
      >
        {popularSearches.map((popularSearch) => (
          <div
            key={popularSearch.id}
            className="p-0.75 flex w-96 items-center justify-start rounded-lg bg-beige-50 hover:bg-beige-50 hover:shadow-shadow10 xs:w-72"
            tabIndex={0}
            role="listitem"
          >
            <Image
              className="w-32 rounded-lg xs:w-24"
              src={popularSearch.image?.value || ''}
              alt={popularSearch.label?.value || ''}
              width="300"
              height="300"
            />
            <div className="flex w-48 flex-col justify-center gap-2">
              <p className="overflow-hidden overflow-ellipsis text-lg font-bold">
                {popularSearch.label?.value || ''}
              </p>
              <a
                href={getURLWithLocalePrefix(popularSearch.path?.value?.href || '')}
                role="link"
                className="w-24 cursor-pointer text-xs font-bold"
              >
                <span className="flex items-center gap-1 font-normal text-[0.75]">
                  {learnMoreText} <JabraIcon Icon={icon_arrow_right} className="h-3 pl-1" />
                </span>
              </a>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
